export const invoiceLabels: Record<string, string> = {
  VENCIDO: "Vencido",
  PAGO: "Pago",
  A_VENCER: "A vencer",
};
